// src/utils/reservationTimer.js
export const END_KEY  = 'reservation_countdown_end';
export const DONE_KEY = 'reservation_countdown_done';

/**
 * Always reset the countdown:
 *  - clear any existing END_KEY or DONE_KEY
 *  - set end-time = now + (minutes*60 + seconds)*1000
 */
export function seedReservationTimer(minutes, seconds) {
  if (typeof window === 'undefined') return;
  // always clear…
  localStorage.removeItem(END_KEY);
  localStorage.removeItem(DONE_KEY);
  // …and reseed
  const endTime = Date.now() + (minutes * 60 + seconds) * 1000;
  localStorage.setItem(END_KEY, endTime.toString());
}
